import React from 'react';

interface DefinitionSearchOutlineIconProps {
  size?: number;
  color?: string;
}

const DefinitionSearchOutlineIcon: React.FC<DefinitionSearchOutlineIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 12.5002c1.3807 0 2.5 -1.1192 2.5 -2.5 0 -1.38067 -1.1193 -2.49996 -2.5 -2.49996 -1.38071 0 -2.5 1.11929 -2.5 2.49996 0 1.3808 1.11929 2.5 2.5 2.5Z" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <path d="m13.4995 13.4998 -1.73 -1.73" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 2.00024v0C7 1.17182 6.32843 0.500244 5.5 0.500244h-5V10.5002h5" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 2.00024v4.5" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 2v0C7 1.17157 7.67157 0.5 8.5 0.5h5v7.00024" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default DefinitionSearchOutlineIcon;
